import { useCallback } from "react";

import { apiClient } from "../../lib/api";

import type { ApiPayload } from "common/classes/api-payload";

export function useConfirmAccount(): (email: string, confirmAccountToken: string) => Promise<ApiPayload> {
  const confirmAccount = useCallback(async (email: string, confirmAccountToken: string): Promise<ApiPayload> => {
    const response = await apiClient.confirmAccount(email, confirmAccountToken);

    if (!response.success) {
      throw new Error(response.message ?? `unexpectedError`);
    }

    return response;
  }, []);

  return confirmAccount;
}
